import Edit from "../../layouts/Edit";
import ProfileImage from "./ProfileImage";
import { useState } from "react";
import { updateProfilePicture } from "../../slice/profile/profileSlice";
import { useDispatch } from "react-redux";
import { resize } from "../../utils/image/resize";

const EditProfile = ({ profile_image, store_name, phone, toggleBackdrop }) => {
  const dispatch = useDispatch();
  const [storename, setStorename] = useState(store_name);
  const [phonenumber, setPhonenumber] = useState(phone);

  const [loading, setLoading] = useState(false);

  const handleChangeProfile = (e) => {
    setLoading(true);
    const file = e.target.files[0];
    resize(file, 400).then((result) => {
      if (result) {
        dispatch(updateProfilePicture(result));
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  const handleEdit = async () => {
    toggleBackdrop();
  };

  return (
    <Edit widthXL="md:w-646">
      <div className="flex gap-2 md:gap-5 items-center">
        <ProfileImage
          widthSm="w-20"
          heightSm="h-20"
          widthMd="md:w-96"
          heightMd="md:h-96"
          leadingMd="md:leading-96"
          leadingSm="leading-20"
          profile_image={profile_image}
          store_name={store_name}
        />
        <div className="">
          <h4 className="font-normal text-base md:text-2xl">{`${store_name}
            's Thrift`}</h4>
          <div className="relative">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-0 md:gap-8">
              <p className="text-logoRed text-xs md:text-base cursor-pointer w-fit">
                Change profile picture
              </p>
              {loading && <p className="text-logoRed font-bold">Updating...</p>}
            </div>
            <input
              type="file"
              onChange={handleChangeProfile}
              className="absolute top-0 w-36 opacity-0 cursor-pointer"
            />
          </div>
        </div>
      </div>

      <div className="flex gap-2 mt-8">
        <div className="w-full md:w-49.5% h-addressHeight">
          <input
            type="text"
            placeholder="Storename/Username"
            value={storename}
            onChange={(e) => setStorename(e.target.value)}
            required
            className="w-full outline-none border-b border-solid border-label focus:border-logoRed"
          />
        </div>
        <div className="w-full md:w-49.5% h-addressHeight">
          <input
            type="text"
            placeholder="phone number"
            value={phonenumber}
            onChange={(e) => setPhonenumber(e.target.value)}
            required
            className="w-full outline-none border-b border-solid border-label focus:border-logoRed"
          />
        </div>
      </div>
      <div className="flex justify-end mt-8 gap-5 itens-center">
        <button
          className="w-24 h-10 rounded-3xl font-bold outline-none border border-black text-black"
          onClick={toggleBackdrop}
        >
          Close
        </button>
        <button
          className={`w-24 h-10 rounded-3xl font-bold outline-none 
                  bg-logoRed
                  text-white`}
          disabled={loading}
          onClick={handleEdit}
        >
          {loading ? "Saving..." : "save"}
        </button>
      </div>
    </Edit>
  );
};

export default EditProfile;
